import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./CaseStudies.module.css";
import { CASE_STUDIES } from "../../../data/resources";
import { Animate, Stagger } from "../../animations";

const CaseStudies = () => {
  return (
    <section className={styles.caseStudies}>
      <div className={styles.caseStudiesInner}>
        <Animate variant="fadeUp">
          <h4 className={styles.caseStudiesHeading}>Success Stories</h4>
          <h1 className={styles.caseStudiesTitle} id="heading-large">
            How We Helped Students Fly
          </h1>
          <p className={styles.caseStudiesDescription}>
            Real stories from students who achieved their study-abroad dreams with
            Ever Sky Overseas.
          </p>
        </Animate>
        <Stagger
          className={styles.caseStudiesCards}
          variant="fadeUp"
          stagger={120}
        >
          {CASE_STUDIES.map((study) => (
            <div key={study.title} className={`${styles.caseStudyCard} anim-hover-lift`}>
              <img src={study.image} alt={study.title} className={styles.caseStudyImage} />
              <div className={styles.caseStudyContent}>
                <h2>{study.title}</h2>
                <NavLink to={study.route} className={styles.readMoreLink}>
                  Read more
                </NavLink>
                <hr className={styles.divider} />
                <p className={styles.caseStudyPara}>{study.description}</p>
              </div>
            </div>
          ))}
        </Stagger>
      </div>
    </section>
  );
};

export default CaseStudies;
